// TODO: ideally this uses the shared eventTracker in /app/src/scripts/eventTracker.js
// however, this is cjs and not in the shared package folder and I didn't want to risk
// moving it rn. - MJS 2025-09-19 GA Launch

import { POST } from "./utils";
import { AnalyticsEventPayload } from "@/analytics/types";

export const postEvent = async (
    event: AnalyticsEventPayload,
    { isAnonymous }: { isAnonymous: boolean }
) => {
    let endpoint = isAnonymous ? "/query/anonevent" : "/query/event";

    return await POST(endpoint, event);
};
